import React from 'react'
import GenericReport from '../GenericReport'

const TreatmentsByBranchPage: React.FC = () => {
  return <GenericReport reportId={3} />
}

export default TreatmentsByBranchPage
